// extracted by mini-css-extract-plugin
module.exports = {"player-wave-canvas":"player-wave-canvas_player-wave-canvas__9r_B_","player-wave-canvas__canvas":"player-wave-canvas_player-wave-canvas__canvas__5pD6d"};